import { render, staticRenderFns } from "./PreparationVisasMailPopup.vue?vue&type=template&id=68cb18a0&"
import script from "./PreparationVisasMailPopup.vue?vue&type=script&lang=js&"
export * from "./PreparationVisasMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports